module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAgCAYAAADT5RIaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABvSURBVHgBHYtBDoMwDATdrZNW6oGU/z/SCCRInMTYXFY7Hi+RyB9LrSvoxIJvfxVAqYCjpQsF2Vxw9ZY0bhrY2UV7/lyweryVfphsB1q2DZ2HQLN5pBno8eCAt5anoIeoHxJM+GKwhmCBxfbY9+0GZCxA/ADTNMgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/rectangle-vertical.png
// module id = 4JzK
// module chunks = 1